module.exports = __webpack_public_path__ + "static/images/containers/Landing/images/landing-promo-ribbon.5eb239dc.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/images/landing-promo-ribbon.png
// module id = 3167
// module chunks = 11